import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';

const CardLineChart = ({ labelsData, dataData }) => {
  const chartRef = useRef(null); // Referencia al canvas
  const chartInstance = useRef(null); // Referencia a la instancia del gráfico

  useEffect(() => {
    if (!chartRef.current) return;

    // Ajusta los datos si hay un solo valor
    const labelsFixed = labelsData.length === 1 ? [...labelsData, ""] : labelsData;
    const dataFixed = dataData.length === 1 ? [...dataData, 0] : dataData;

    // console.log("INFO GRAF LINE", labelsFixed, dataFixed);

    // Si hay una instancia previa, la destruimos antes de crear una nueva
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    const ctx = chartRef.current.getContext('2d');
    chartInstance.current = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: labelsFixed,
        datasets: [
          {
            label: 'Total Equipos',
            backgroundColor: '#f5e90bff',
            borderColor: '#4c51bf',
            data: dataFixed,
            fill: false,
            tension: 0.3, // Suaviza la línea del gráfico
          },
        ],
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          x: {
            grid: {
              display: false,
            },
          },
          y: {
            grid: {
              display: false,
            },
          },
        },
      },
    });

    // Cleanup: destruimos el gráfico cuando el componente se desmonta
    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [labelsData, dataData]); // Se ejecuta cuando los datos cambian

  return (
    <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
      <div className="rounded-t mb-0 px-4 py-3 bg-transparent">
        <div className="flex flex-wrap items-center">
          <div className="relative w-full max-w-full flex-grow flex-1">
            <h6 className="uppercase text-blueGray-400 mb-1 text-xs font-semibold">
              Ocupación
            </h6>
            <h2 className="text-blueGray-700 text-xl font-semibold">
              Equipos
            </h2>
          </div>
        </div>
      </div>
      <div className="p-4 flex-auto">
        <div className="relative h-350-px">
          <canvas ref={chartRef}></canvas> {/* Usamos ref en lugar de id */}
        </div>
      </div>
    </div>
  );
};

export default CardLineChart;
